import { render, staticRenderFns } from "./forgetPasswordModal.vue?vue&type=template&id=7552d979&scoped=true&"
import script from "./forgetPasswordModal.vue?vue&type=script&lang=js&"
export * from "./forgetPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./forgetPasswordModal.vue?vue&type=style&index=0&id=7552d979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7552d979",
  null
  
)

export default component.exports